import { useQuery } from "@tanstack/react-query";
import { fetchUserLibrary } from "./api/products";

export const useGetUserLibrary = (user_id) => {
  return useQuery({
    queryKey: ["userLibrary", user_id],
    queryFn: () => fetchUserLibrary(user_id),
  });
};
